// What an Autocomplete's input box holds, apart from React. A pick from a list (not freeSolo) opens EMPTY with the
// current choice as the placeholder, as a select box does: its label is not something to edit, and leaving it in
// the box made every search start by deleting it. Free text opens with its value, ready to edit one character.

/** The text the box starts with when it opens. */
export const openingQuery = (freeSolo, committed) => (freeSolo ? committed : '');

/** The placeholder the box shows: the current choice while an empty list-picker is open, else the field's own. */
export const inputPlaceholder = ({
    isOpen, freeSolo, committed, placeholder,
}) => (isOpen && !freeSolo && committed ? committed : placeholder);
